import React, { useRef, useEffect } from "react";
import NotificationsIcon from "@material-ui/icons/Notifications";
import useNotificationStore from "../../Store/Notifications/NotificationStore";
import NotificationPanel from "../NotificationPanel/NotificationPanel";
import styles from "./NotificationIcon.module.scss";

interface NotificationIconProps {
  className?: string;
}

const NotificationIcon: React.FC<NotificationIconProps> = ({ className }) => {
  const unreadCount = useNotificationStore((state) => state.unreadCount);
  const isOpen = useNotificationStore((state) => state.isOpen);
  const toggleOpen = useNotificationStore((state) => state.toggleOpen);
  const close = useNotificationStore((state) => state.close);
  const notificationRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (
        notificationRef.current &&
        !notificationRef.current.contains(event.target as Node) &&
        isOpen
      ) {
        close();
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [isOpen, close]);

  const handleToggleNotifications = (e: React.MouseEvent) => {
    e.stopPropagation();
    toggleOpen();
  };

  return (
    <div
      ref={notificationRef}
      className={`${styles.notificationContainer} ${className || ""}`}
    >
      <div
        className={styles.notificationIcon}
        onClick={handleToggleNotifications}
      >
        <NotificationsIcon />
        {unreadCount > 0 && (
          <span className={styles.notificationBadge}>
            {unreadCount > 9 ? "9+" : unreadCount}
          </span>
        )}
      </div>
      {isOpen && <NotificationPanel />}
    </div>
  );
};

export default NotificationIcon;
